// extracted by mini-css-extract-plugin
export default {"icons":"ConditionsCard_icons__phFGo","greyText":"ConditionsCard_greyText__H1lwZ"};